import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useHistoricalEmployeeDataStore
 *
 * Backs the Admin Setup > Organization Hierarchy > "Historical Employee
 * Data" upload tab (HistoricalEmployeeDataUpload.jsx) — a frontend-only
 * placeholder, no backend/BigQuery table yet. Stores whatever rows were
 * last confirmed from an uploaded file (Emp Id, role identity fields, Role
 * Start Date, Role End Date — multiple rows per employee allowed). This is
 * meant to eventually ground Talent Mobility's Career Path tenure estimates
 * (currently LLM-only, see the algorithm design doc's Engine A section) in
 * real per-role duration data — not consumed by any Talent Mobility screen
 * yet, purely a data-capture placeholder for now.
 * Session-only by design — Talent Mobility data must not live in localStorage.
 */
const useHistoricalEmployeeDataStore = create(
  devtools(
    (set) => ({
      records: [],
      setRecords: (records) => set({ records }),
      clearRecords: () => set({ records: [] }),
    }),
    { name: 'HistoricalEmployeeDataStore' }
  )
);

// The store used to be persisted under this key — drop the stale entry so
// browsers that uploaded data before the change don't keep dead data.
try {
  window.localStorage.removeItem('tm-historical-employee-data');
} catch {
  // storage unavailable (SSR/blocked) — nothing to clean up
}

export default useHistoricalEmployeeDataStore;
